<div class="mz-info-message">
  <img [src]="'../../assets/images/zilla_monster.svg'" class="monster-icon" />
  <div class="speech-bubble">
    <p class="speech-bubble-text" *ngIf="type == 'trend'">
      That's a lot of data! Try adding filters or switching to a
      <button
        class="btn btn-link table-link-button"
        (click)="switchToTable.emit()"
      >
        table
      </button>
      view.
    </p>
    <p class="speech-bubble-text" *ngIf="type == 'distribution'">
      That's a lot of data! Try selecting only one time period or adding
      filters.
    </p>
    <p class="speech-bubble-text pr-1" *ngIf="type == 'tooMuchData'">
      Uh oh! That's too much data to show in this graph. You can
      <button
        class="btn btn-link table-link-button"
        (click)="triggerExport.emit()"
      >
        export</button
      >, view in a
      <button
        class="btn btn-link table-link-button"
        (click)="switchToTable.emit()"
      >
        table
      </button>
      or add filters.
    </p>
    <button
      class="btn btn-link hide-button"
      *ngIf="type != 'tooMuchData'"
      (click)="hideMZInfoMessage.emit()"
    >
      GOT IT
    </button>
  </div>
</div>
